import { TaskProps } from "@/interfaces/tasks_types";
import { SubmittalProps } from "@/interfaces/submittal_types";

export const NamesInCategory = (tasks: TaskProps[] | SubmittalProps[]): Record<string, string[]> => {
    let names: Record<string, string[]> = {
        "Mechanical": [],
        "Electrical": [],
        "Plumbing": [],
        "Fire Protection": [],
        "Other": []
    };

    tasks.forEach(task => {
        if (task.category.toLocaleLowerCase() === "fire protection") {
            names["Fire Protection"].push(task.assigned_to);
        } else {
            names[task.category as keyof typeof names].push(task.assigned_to);
        }
    })
    
    // Filter out duplicate names in each category
    Object.keys(names).forEach(category => {
        names[category] = Array.from(new Set(names[category]));
    });

    return names;
};
